import React from 'react';
import classNames from 'classnames';
import ToggleContainer from '../../Containers/toggleContainer';
import ExpandableButton from '../../Buttons';
import SemanticHeader from '../../Chapter/semantic-header';

const ContactCardPanel = (props) => {
  return (
    <ToggleContainer subheading={props.subheading} open={props.open}>
      {({ open, animation, toggle }) => (
        <div
          className={classNames({
            'contact-card': true,
            'contact-card--open': open,
            subheading: props.subheading,
            'is-last': props.isLast,
            ...props.Modifiers,
          })}
          id={props.id}
        >
          <div className="contact-card__inner">
            <div className="contact-card__content">
              <div className="contact-card__button-container">
                <SemanticHeader
                  className={`contact-card__content__heading ${props.matomoTrackingClass ? props.matomoTrackingClass : ''}`}
                  isH3={props.hasH3}
                  isH4={props.hasH4}
                >
                  <ExpandableButton
                    onClick={toggle}
                    open={open}
                    buttonClass="contact-card__button"
                    iconClass={
                      props.subheading
                        ? 'plus--subheading'
                        : 'chevron--contact-panel'
                    }
                    buttonText={props.contactCardHeading}
                    textClass="contact-card__heading"
                    buttonId={`contact-card-accordion-${props.id}`}
                  />
                </SemanticHeader>
              </div>

              <div
                className={classNames({
                  'contact-card__content__inner': true,
                  animation: animation,
                })}
              >
                {props.children}
              </div>
            </div>
          </div>
        </div>
      )}
    </ToggleContainer>
  );
};

export default ContactCardPanel;
